import { render } from "./PlanFeatureLocked.vue?vue&type=template&id=526c53ac&scoped=true&ts=true"
import script from "./PlanFeatureLocked.vue?vue&type=script&lang=ts"
export * from "./PlanFeatureLocked.vue?vue&type=script&lang=ts"

import "./PlanFeatureLocked.vue?vue&type=style&index=0&id=526c53ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526c53ac"]])

export default __exports__